import { createAsyncThunk } from "@reduxjs/toolkit";
import { TalesFood } from "../../../utils/types/TalesFood";
import { db } from "../../../firebase/config";

export const toggleFoodVisibility = createAsyncThunk(
  "food/toggleVisibility",
  async (food: TalesFood) => {
    try {
      const querySnapshot = await db
        .collection("food")
        .where("title", "==", food.title)
        .get();

      return querySnapshot.docs[0].ref.set({ ...food, show: !food.show });
    } catch (e: any) {
      console.log(e);

      return Promise.reject(
        `Food non ${food.show ? "nascosto" : "mostrato"}, ${e.message}`,
      );
    }
  },
);
